var installedModules = {};
var moduleToHandlerMapping = {
	984: {
		getter: () => (__webpack_require__.e(4791).then(() => (() => (__webpack_require__(7172))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.13",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/animations",
	},
	1108: {
		getter: () => (__webpack_require__.e(1398).then(() => (() => (__webpack_require__(1398))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/cdk",
	},
	2194: {
		getter: () => (__webpack_require__.e(7935).then(() => (() => (__webpack_require__(316))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.13",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	3516: {
		getter: () => (__webpack_require__.e(781).then(() => (() => (__webpack_require__(3162))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.1.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "mobx-react-lite",
	},
	6156: {
		getter: () => (__webpack_require__.e(2075).then(() => (() => (__webpack_require__(4456))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.13",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/forms",
	},
	6207: {
		getter: () => (__webpack_require__.e(354).then(() => (() => (__webpack_require__(7973))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@pflm-shared",
	},
	6470: {
		getter: () => (__webpack_require__.e(1543).then(() => (() => (__webpack_require__(3924))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.13",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/router",
	},
	7386: {
		getter: () => (__webpack_require__.e(920).then(() => (() => (__webpack_require__(920))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	7715: {
		getter: () => (__webpack_require__.e(8055).then(() => (() => (__webpack_require__(436))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.13",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/platform-browser",
	},
	8025: {
		getter: () => (__webpack_require__.e(7254).then(() => (() => (__webpack_require__(4873))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.85.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@tanstack/react-query-persist-client",
	},
	8236: {
		getter: () => (__webpack_require__.e(7404).then(() => (() => (__webpack_require__(7404))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.13",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	8934: {
		getter: () => (__webpack_require__.e(5485).then(() => (() => (__webpack_require__(5485))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	9525: {
		getter: () => (__webpack_require__.e(3165).then(() => (() => (__webpack_require__(5546))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.8.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	},
	9649: {
		getter: () => (__webpack_require__.e(8824).then(() => (() => (__webpack_require__(6443))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.13",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common/http",
	},
	9237: {
		getter: () => (__webpack_require__.e(9745).then(() => (() => (__webpack_require__(9745))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "6.13.7",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "mobx",
	},
	9019: {
		getter: () => (__webpack_require__.e(1347).then(() => (() => (__webpack_require__(3728))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.85.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@tanstack/react-query",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"316": [
		8236
	],
	"354": [
		9237
	],
	"436": [
		2194,
		8236,
		9649
	],
	"781": [
		9237
	],
	"3162": [
		7386,
		8934,
		9237
	],
	"3728": [
		7386
	],
	"3924": [
		2194,
		7715,
		8236
	],
	"4456": [
		2194,
		8236
	],
	"4873": [
		7386,
		9019
	],
	"5546": [
		7386,
		8934
	],
	"5744": [
		9019
	],
	"6443": [
		2194,
		8236
	],
	"7172": [
		2194,
		8236
	],
	"7254": [
		9019
	],
	"7866": [
		7386
	],
	"7973": [
		7386,
		8025,
		9237
	],
	"8055": [
		9649
	],
	"8961": [
		984,
		1108,
		2194,
		3516,
		6156,
		6207,
		6470,
		7386,
		7715,
		8025,
		8236,
		8934,
		9525,
		9649
	],
	"9017": [
		8236
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}